import { render, staticRenderFns } from "./ReportPayments.vue?vue&type=template&id=4151dfa6"
import script from "./ReportPayments.vue?vue&type=script&lang=js"
export * from "./ReportPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports